const OVERVIEW = "OVERVIEW";
const FIRMWARE = "FIRMWARE";
const DIAGNOSTIC = "DIAGNOSTIC";
const SETTINGS = "SETTINGS";
const BATTERY_HEALTH = "BATTERY_HEALTH";

const dashboardSections = {
  OVERVIEW,
  FIRMWARE,
  DIAGNOSTIC,
  SETTINGS,
  BATTERY_HEALTH
};

export default dashboardSections;
